import { Component, CreateEffectOptions, effect, inject, input, output, signal } from '@angular/core';
import { ChartsModule, SeriesClickEvent } from '@progress/kendo-angular-charts';
import { IntlService } from '@progress/kendo-angular-intl';
import { MttdData } from '../../../../../../../core/services/analytics.service';
import { BaseComponent } from '../../../../../../../core/shared/common/base.component';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { CommonModule } from '@angular/common';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { ChartLabelsPopupService } from '../../../../../../../core/shared/common/chart-labels-popup.service';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { GridModule, ExcelModule, GridDataResult } from '@progress/kendo-angular-grid';
import { MttdDetailsService } from './services/mttddetails.service';
import { environment } from '../../../../../../../../environments/environment';
import { Observable } from 'rxjs';
import { DATE_FILTER_OPERATORS } from 'src/app/core/constants/filter-operators';

@Component({
  selector: 'app-mttd',
  standalone: true,
  imports: [
    ChartsModule,
    LoaderModule,
    CommonModule,
    LabelModule,
    InputsModule,
    FormsModule,
    DialogsModule,
    GridModule,
    ExcelModule,
  ],
  templateUrl: './mttd.component.html',
  styleUrl: './mttd.component.scss',
  providers: [MttdDetailsService],
})
export class MttdComponent extends BaseComponent {
  public gridService = inject(MttdDetailsService);
  public popupService = inject(ChartLabelsPopupService);
  public checked = false;
  public mttdData = input<MttdData[]>([]);
  public seriesClick = output<SeriesClickEvent>();
  public caseFilterChanged = output<boolean>();
  public isLoading = signal(true);
  public chartData = signal<MttdData[]>([]);
  public organizationId = input<number | null>();
  public dateRange = input<string[] | null>(null);
  public items: any[] = [{ text: 'View Data' }];
  public showPopup = false;
  public dateFilterOperators = DATE_FILTER_OPERATORS;

  constructor(private intl: IntlService) {
    super();
    this.initEffect();
  }

  private initEffect() {
    effect(
      () => {
        const data = this.mttdData();
        const filteredData = data ? data.filter((item) => item.description !== null) : [];
        this.chartData.set(filteredData);
        this.isLoading.set(false); // Set to false regardless of data presence
      },
      { allowSignalWrites: true } as CreateEffectOptions
    );
  }

  public caseFilter() {
    this.caseFilterChanged.emit(this.checked);
  }

  public handleSeriesClick(event: SeriesClickEvent): void {
    this.seriesClick.emit(event);
  }

  onContextMenuSelect(event: any) {
    if (event?.text === 'View Data') {
      this.gridService.setDateRange(this.dateRange());
      this.gridService.url = `${environment.apiUrl}/v1/analytics/administrative/mttddetails(${this.organizationId()})`;
      this.gridService.read();
      this.showPopup = true;
    } else {
      console.warn('Invalid event structure:', event);
    }
  }

  public allData = (): Observable<GridDataResult> => {
    return this.gridService.queryAll();
  };

  // Close popup
  close() {
    this.showPopup = false;
  }
}
